<div class="container-fluid fast-quote-target-price">

  <div [hidden]="submit">
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <a backButton>
          <i class="icon-edponline-Bra-073 rotate-90 font-size-24 color-black"></i>
        </a>
      </div>
      <div class="col-12 text-center fast-quote-title mt-4 mb-3">
        <span class="d-block">{{'edp.emarket.fast.quote.pending.fast' | translate}}</span>
        <span class="pb-3">{{'edp.emarket.fast.quote.pending.price' | translate}}</span>
      </div>
    </div>

    <div class="row line"></div>

    <form [formGroup]="fastQuoteTargetForm" (ngSubmit)="onSubmit()" class="row px-2 mt-3">
      <div class="form-group col-6 col-md-4 offset-md-2 mb-0">
        <label for="maturidade1" class="mat-val-label">
          {{'edp.emarket.fast.quote.maturidade' | translate}}
        </label>
        <mat-form-field floatLabel="never">
          <mat-label class="select-text">{{'edp.emarket.fast.quote.opcao' | translate}}</mat-label>
          <mat-select
            formControlName="maturity"
            panelClass="edit-alert-variation"
            >
            <mat-option disabled>
              <div class="d-flex justify-content-between align-items-center">
                <span class="pt-2 font-size-16">{{'edp.emarket.fast.quote.opcao' | translate}}</span>
                <i
                  class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"
                ></i>
              </div>
            </mat-option>
            @for (val of maturityValues; track val) {
              <mat-option value="{{ val }}">{{
                val
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group col-6 col-md-4 mb-0">
        <label for="valor1" class="mat-val-label">
          {{'edp.emarket.fast.quote.valor' | translate}}
        </label>
        <mat-form-field floatLabel="never">
          <mat-label class="select-text">%</mat-label>
          <mat-select
            formControlName="value"
            panelClass="edit-alert-variation"
            >
            <mat-option disabled>
              <div class="d-flex justify-content-between align-items-center">
                <span class="pt-2 font-size-16">%</span>
                <i
                  class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"
                ></i>
              </div>
            </mat-option>
            @for (val of percentageValues; track val) {
              <mat-option value="{{ val }}"
                >{{ val }}%</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group px-3 col-12 col-md-8 offset-md-2 mb-0">
          <span class="mat-val-label"> {{'edp.emarket.detalhe.preco' | translate}}</span>
          <mat-form-field class="w-100 pt-1" floatLabel="never">
            <input matInput placeholder="€" formControlName="price" [pattern]="numberOnly" />
            @if (sent && f.price.errors && f.price.errors.pattern) {
              <div class="pt-3 pl-3 form-label text-danger">
                {{'edp.emarket.price.introduza.numero' | translate}}
              </div>
            }
          </mat-form-field>
        </div>

        <div class="col-12">
          <button
            class="btn bg w-100 mt-3 col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4 px-4"
            type="submit" id="btn-submit">
            <span class="bg-text">{{'edp.emarket.detalhe.avancar' | translate}}</span>
          </button>
        </div>

      </form>
    </div>

    @if (submit) {
      <div>
        <div class="row d-flex justify-content-center">
          <div class="signaling-confirm margin-top-74">
            <span class="d-block">{{'edp.emarket.fast.quote.pending.confirmar.ordem' | translate}}
            </span>
            <span> {{ f.value.value }} {{'edp.emarket.fast.quote.pending.para' | translate}}</span>
            <span> {{ f.maturity.value }}</span>
            <span> a {{ f.price.value }} {{'edp.emarket.fast.quote.pending.euros' | translate}}</span>
          </div>
        </div>
        <div class="row px-4 pt-4 margin-top-33 col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4">
          <button class="btn bg w-100" (click)="confirm()" [disabled]="pending" id="btn-confirm">
            @if (pending) {
              <span class="spinner-border" style="width: 1.25rem; height: 1.25rem;" role="status" aria-hidden="true"></span>
            } @else {
              <span class="bg-text">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
            }
          </button>
        </div>
        <div class="row mt-3 px-4 col-12 offset-md-1 col-md-10 offset-lg-3 col-lg-6 col-xl-4 offset-xl-4">
          <a routerLink="/markets" class="w-100" id="btn-cancel">
            <button class="btn bg-2 w-100">
              <span class="bg-text">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
            </button>
          </a>
        </div>
      </div>
    }
  </div>
